// @todo log level depending on environment
export const Logger = console;
